export default __webpack_public_path__ + "10a196ae9659e5a2474f7ace8d0890d9.png";